<div class="year-range-picker-wrapper relative" [class]="styleClass">
  <div 
    class="year-range-trigger w-full min-w-[200px] border rounded-lg bg-white cursor-pointer transition-all duration-200"
    [class.opacity-50]="disabled"
    [class.cursor-not-allowed]="disabled"
    (click)="toggleDropdown()"
  >
    <div class="flex items-center justify-between px-4 py-2">
      <div class="flex items-center flex-1">
        <svg 
          *ngIf="showIcon"
          class="year-range-icon w-5 h-5 flex-shrink-0"
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
        </svg>
        <span 
          [class.year-range-placeholder]="!displayValue"
          [class.year-range-value]="displayValue"
          class="text-sm font-normal"
          [class.ml-2]="showIcon"
        >
          {{ displayValue || placeholder }}
        </span>
      </div>
      
      <div class="flex items-center gap-2 flex-shrink-0">
        <!-- Close icon - show when year range is selected -->
        <svg
          *ngIf="yearRange && (yearRange.startYear || yearRange.endYear) && !disabled"
          class="year-range-clear-icon w-4 h-4 cursor-pointer"
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
          (click)="clear(); $event.stopPropagation()"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </div>
    </div>
  </div>

  <!-- Year Picker Dropdown -->
  <div
    *ngIf="isOpen"
    class="year-range-panel absolute w-full mt-2 rounded-2xl shadow-lg p-4"
    style="top: 100%; left: 0; min-width: 400px; max-width: 450px; z-index: 9999;"
    (click)="$event.stopPropagation()"
  >
    <!-- Year Picker Header -->
    <div class="flex items-center justify-between mb-4">
      <h3 class="year-range-heading text-base font-semibold">{{ getDecadeRange() }}</h3>
      
      <div class="flex items-center gap-1.5">
        <button
          type="button"
          class="year-range-nav w-8 h-8 flex items-center justify-center rounded-lg transition-colors border-0 outline-none"
          (click)="previousDecade()"
          [disabled]="currentDecade - 20 < minYear"
          aria-label="Previous decade"
        >
          <svg class="year-range-nav-icon w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
          </svg>
        </button>
        
        <button
          type="button"
          class="year-range-nav w-8 h-8 flex items-center justify-center rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed border-0 outline-none"
          (click)="nextDecade()"
          [disabled]="currentDecade + 20 > maxYear"
          aria-label="Next decade"
        >
          <svg class="year-range-nav-icon w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Years Grid -->
    <div class="grid grid-cols-4 gap-2">
      <button
        *ngFor="let year of getYearsInDecade()"
        type="button"
        [class]="getYearClasses(year)"
        [disabled]="year < minYear || year > maxYear"
        (click)="selectYear(year)"
        (mouseenter)="onYearHover(year)"
        (mouseleave)="onYearLeave()"
      >
        {{ year }}
      </button>
    </div>
    
    <!-- Empty cells for years outside range -->
    <div *ngIf="getYearsInDecade().length < 20" class="grid grid-cols-4 gap-2 mt-2">
      <div *ngFor="let _ of [].constructor(20 - getYearsInDecade().length)" class="w-16 h-10"></div>
    </div>
  </div>
</div>

